module.exports = __webpack_public_path__ + "img/STQ.2dca4853.svg";